import { AreaRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathAreaPicker, MathPickerContribution } from "../constants";

import { DefaultMathAreaPicker } from "./area-picker";

let loadAreaPick = !1;

export function bindAreaMathPickerContribution(container) {
    loadAreaPick || (loadAreaPick = !0, container.bind(MathAreaPicker).toDynamicValue((() => new DefaultMathAreaPicker(resolveContainerBinding(container, AreaRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathAreaPicker));
}
//# sourceMappingURL=area-module.js.map
